import { db } from "../firebase";
import {
  doc,
  setDoc,
} from "firebase/firestore";
import { FB_COLLECTION_PATH } from "./postActionTypes";


export async function fx_FB_UpdateUserProfile(requestorUID: string, newCompany: string, newFirstName: string, newLastName: string, newOccupation: string, newBio: string) {
  // updates current user's profile
  const userRef = doc(db, FB_COLLECTION_PATH.Users, requestorUID);
  await setDoc(userRef, {
    company: newCompany,
    firstName: newFirstName,
    lastName: newLastName,
    occupation: newOccupation,
    userBio: newBio,
  }, { merge: true });

  const userRef2 = doc(db, `${FB_COLLECTION_PATH.Users}/${requestorUID}/${FB_COLLECTION_PATH.UsersPublicFacing}`, requestorUID);
  await setDoc(userRef2, {
    company: newCompany,
    firstName: newFirstName,
    lastName: newLastName,
    occupation: newOccupation,
    userBio: newBio,
  }, { merge: true });
  
  const userRef3 = doc(db, `users/${requestorUID}/users_AssociateFacing`, requestorUID);
  await setDoc(userRef3, {
    company: newCompany,
    firstName: newFirstName,
    lastName: newLastName,
    occupation: newOccupation,
    userBio: newBio,
  }, { merge: true });
  return ({"status":"sent"})
};

export async function fx_FB_UpdateUserLastRole(requestorUID: string, newRole: boolean) {
  // updates current user's associate request
  const userRef = doc(db, FB_COLLECTION_PATH.Users, requestorUID);
  await setDoc(
    userRef,
    {
      userLastRoleScheduler: newRole,  
    },
    { merge: true }
  ); 
  return ({"status":"sent"})
};

export async function fx_FB_UpdateOnboardingSeen(requestorUID: string, field: "onboardingWerkerSeen" | "onboardingSchedulerSeen") {
  const userRef = doc(db, FB_COLLECTION_PATH.Users, requestorUID);
  await setDoc(userRef, { [field]: true }, { merge: true });
  return ({"status":"sent"})
};

export async function fx_FB_DeleteUserAccount(requestorUID: string, requestorFName: string) {
  // updates current user's associate request
  const userRef = doc(db, `users/${requestorUID}/deleteAccount`, requestorUID);
  await setDoc(
    userRef,
    {
      deletionRequestDate: Date.now(),
      userFirstName: requestorFName,
      userID: requestorUID,  
    },
  ); 
  return ({"status":"sent"})
};

